import { render, staticRenderFns } from "./AdviceList.vue?vue&type=template&id=4dd770ce&"
import script from "./AdviceList.vue?vue&type=script&lang=ts&"
export * from "./AdviceList.vue?vue&type=script&lang=ts&"
import style0 from "./AdviceList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports